<template>
  <div>
    <main v-loading="roleLoading">
      <div class="card-title">角色管理</div>
      <div>
        <el-input placeholder="请输入角色名" v-model="roleName" class="search-role" @keydown.native.enter="getRoleList">
          <el-button slot="append" icon="el-icon-search" @click="getRoleList"></el-button>
        </el-input>
        <ul
          class="roles"
          v-if="roleList.length">
          <li
            class="role-item"
            :class="{active: currentRole === role.roleId}"
            v-for="role in roleList"
            :key="role.roleId"
          >
            <div class="role-item-box" v-if="role.editing">
              <el-input
                v-focus
                v-model="role.roleName"
                clearable
                @keydown.enter.native="resolveRole(role)"
              ></el-input>
              <a
                class="icon"
                href="javascript: void 0"
                @click="cancelEdit(role)"
              >
                <icon-svg class="wrong-icon" icon-class="close"></icon-svg>
              </a>
              <a
                class="icon"
                href="javascript: void 0"
                @click="resolveRole(role)"
              >
                <icon-svg class="right-icon" icon-class="right"></icon-svg>
              </a>
            </div>
            <div class="role-item-box" v-else>
              <span
                @click="$emit('update:currentRole', role.roleId)"
                @dblclick="editRole(role)"
              >{{role.roleName}}</span>
              <a class="icon show-on-hover" href="javascript: void 0" @click="editRole(role)">
                <icon-svg icon-class="edit"></icon-svg>
              </a>
              <a class="icon show-on-hover" href="javascript: void 0" @click="deleteRole(role)">
                <icon-svg icon-class="delete"></icon-svg>
              </a>
            </div>
          </li>
        </ul>
        <div class="no-data-normal" v-else>暂无数据</div>
      </div>
    </main>
    <footer>
      <a class="add-role-btn" href="javascript: void 0" @click="addRole">
        + 添加角色
      </a>
    </footer>
  </div>
</template>

<script>
import {system} from '../../api'

export default {
  name: 'AuthRoleManagement',

  directives: {
    focus: {
      inserted: el => el.querySelector('input').focus()
    }
  },

  props: {
    currentRole: String
  },

  data () {
    return {
      roleList: [],
      // 角色搜索框内容
      roleName: '',
      roleLoading: false
    }
  },

  methods: {
    async getRoleList () {
      this.roleLoading = true
      let {data} = await system.getRoleList(this.roleName, this.$store.state.user.roleId)
      this.roleLoading = false
      this.roleList = data.map(x => ({...x, oldName: x.roleName, editing: false}))
    },
    addRole () {
      for (let role of this.roleList) {
        role.editing = false
      }
      this.roleList.push({
        roleId: 'add' + Date.now(),
        roleName: '',
        oldName: '',
        editing: true
      })
    },
    editRole (role) {
      for (let role of this.roleList) {
        role.editing = false
      }
      role.editing = true
    },
    resolveRole (role) {
      if (!role.roleName.trim()) return
      role.editing = false
      if (role.roleId.startsWith('add')) {
        this.serverAddRole(role)
      } else {
        this.serverUpdateRole(role)
      }
    },
    async serverAddRole (role) {
      try {
        let {code, msg, data} = await system.addRole(role.roleName)
        if (code !== 0) throw new Error(msg)
        role.oldName = role.roleName
        role.roleId = data.roleId
      } catch (e) {
        this.$message({
          type: 'error',
          message: e.message || '角色添加失败'
        })
        this.roleList.pop()
      }
    },
    async serverUpdateRole (role) {
      try {
        let {code, msg, data} = await system.updateRole(role.roleId, role.roleName)
        if (code !== 0) throw new Error(msg)
        role.oldName = role.roleName
      } catch (e) {
        this.$message({
          type: 'error',
          message: e.message || '角色更新失败'
        })
        role.roleName = role.oldName
      }
    },
    deleteRole (role) {
      this.$confirm('确定要删除该角色吗？', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let {code, msg} = await system.deleteRole(role.roleId)
        if (code === 0) {
          let index = this.roleList.findIndex(x => x.roleId === role.roleId)
          this.roleList.splice(index, 1)
        } else {
          this.$message({
            type: 'error',
            message: msg || '按钮删除失败'
          })
        }
      }, err => {
        console.log(err)
      })
    },
    cancelEdit (role) {
      role.editing = false
      if (role.oldName) {
        role.roleName = role.oldName
      } else {
        this.roleList.pop()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.no-data-normal {
  text-align: center;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.search-role /deep/ .el-input-group__append button {
  padding: 12px;
}
.roles {
  padding-top: 20px;
}
.role-item {
  height: 48px;
  color: #666;
  border-top: 1px solid #eee;

  .icon.show-on-hover {
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  &:hover {
    .icon.show-on-hover {
      opacity: 1;
    }
  }

  .role-item-box {
    display: flex;
    align-items: center;
    height: 100%;

    & > * {
      flex-shrink: 0;
    }

    & > :first-child {
      flex-shrink: 1;
      flex-grow: 1;
    }

    .icon:not(:first-child) {
      margin-left: 0.5em;
    }

    & > span {
      cursor: pointer;
    }
  }

  &.active, &:active {
    color: $main-color;
  }
}
.add-role-btn {
  color: #333;
}
.right-icon {
  color: $success;
  font-size: 18px;
  margin-bottom: -0.1em;
}
.wrong-icon {
  color: red;
  font-size: 12px;
}
</style>
